import { useState } from "react";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import styles from "./UserStatusModal.module.scss";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../redux/store";
import {
  setIsLogin,
  setIsRegister,
  setIsUserStatus,
  setUserStatus,
} from "../../../../../redux/Slices/userSlice";
import CloseLeft from "../../../../../assets/images/pages/login/CaretLeft.svg";
import CloseIcon from "../../../../../assets/images/pages/login/CloseButton.svg";
import logo from "../../../../../assets/images/site-logo/Logo.png";

const UserStatusModal = () => {
  const [isModal, setIsModal] = useState(false);
  const dispach = useDispatch();
  const { data } = useSelector((state: RootState) => state.translationData);
  const LoginClose = () => {
    dispach(setIsUserStatus(false));
    dispach(setIsLogin(true));
  };
  return (
    <GlobalModalComponent isOpen={true} onClose={() => setIsModal(!isModal)}>
      <div className={styles.useStatusModal}>
        <div className={styles.headerLogin}>
          <div className={styles.headerLeft} onClick={LoginClose}>
            <img className={styles.backLoginIcon} src={CloseLeft} alt="left" />
            <p className={styles.backLoginText}>Daxil ol</p>
          </div>
          <Link to={"/"} onClick={LoginClose} className={styles.closeButton}>
            <img
              className={styles.closeIcon}
              src={CloseIcon}
              alt="EyeIcon"
              onClick={LoginClose}
            />
          </Link>
        </div>
        <div className={styles.modalContainer}>
          <div className={styles.logo}>
            <img src={logo} alt="colibri" />
          </div>
          <h3 className={styles.loginTitle}>{data?.login_registration_type}</h3>
          <div className={styles.btns_container}>
            <div
              className={styles.user_status_btn}
              style={{ backgroundColor: "#36654a" }}
              onClick={() => {
                dispach(setIsUserStatus(false));
                dispach(setIsRegister(true));
                dispach(setUserStatus("Hüquqi şəxs"));
              }}
            >
              {data?.legal}
            </div>
            <div
              className={styles.user_status_btn}
              style={{ backgroundColor: "#f05922" }}
              onClick={() => {
                dispach(setIsUserStatus(false));
                dispach(setIsRegister(true));
                dispach(setUserStatus("Fiziki şəxs"));
              }}
            >
              {data?.physical}
            </div>
          </div>
        </div>
      </div>
    </GlobalModalComponent>
  );
};

export default UserStatusModal;
